export function authHeader() {
  //return authorization header with basic auth credentials
  let auth_token = localStorage.getItem('auth_token');

  if (auth_token) {
      return { 'Authorization' : 'Bearer ' + auth_token };
  } else {
      return {};
  }
}